import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Update, GetById, GetAllProducts } from "adminApi/DestroyeItemApi/DestroyedItem";
import fields from "../json/DestroyedFields.json";
import { validateForm } from "utils/validation";
import { DestroyedItemsRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditDestroyedForm from "./Componates/EditDestroyedListForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import useFetchAllData from "Hooks/useFetchAllData";

const EditDestroyedList = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = fields;

  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setErrors, setValues } = useFormChange(
    initialValues,
    DestroyedItemsRules
  );

  // Pre-fill form with existing record
  const { loading: loadingFetch } = useFetchFormDataById(id, formdata, GetById, setValues);

  // Product dropdown — needed so the user can change the product on edit
  const { data: ProductOptions = [], loading: loadingProduct } = useFetchAllData(GetAllProducts);

  // Form submit
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Update({ id, data: formData });
    },
    (vals) => {
      const err = validateForm(vals, DestroyedItemsRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Destroyed item updated successfully."
  );

  return (
    <>
      {(loadingFetch || loadingSubmit || loadingProduct) && <Spinner isSpinner />}
      <EditDestroyedForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        ProductOptions={ProductOptions}
        title="Update"
      />
    </>
  );
};

export default EditDestroyedList;
